import { ColumnDef } from "@tanstack/react-table"
import BillImagePreview from "./BillImagePreview"

export type Expense = {
  id: number
  amount: string
  title: string
  date: string
  type: "daily" | "overall"
  has_bill_image: boolean
}

export const columns: ColumnDef<Expense>[] = [
  // {
  //   header: "User",
  //   cell: ({ row }) => <LetterAvatar name={row.original.name} />,
  // },
  {
    header: "Amount",
    accessorKey: "amount",
  },
  {
    header: "Title",
    accessorKey: "title",
  },
  {
    header: "Date",
    accessorKey: "date",
  },
  {
    header: "Type",
    accessorKey: "type",
    cell: ({ row }) => (row.original.type === "overall" ? "Overall" : "Daily"),
  },
  {
    header: "Bill",
    cell: ({ row }) =>
      row.original.has_bill_image ? (
        <BillImagePreview expenseId={row.original.id} />
      ) : (
        "—"
      ),
  },
]
